registerComponent("blocks/select", function (component) {
/**
 * O corpo recebe o elemento raiz do componente em `component`; o build o
 * envolve em registerComponent(). Os antigos `params` viraram @props no Blade.
 *
 * Este componente não tem comportamento — em 2020 o arquivo era uma linha só,
 * o wrapper da biblioteca, sem nenhum uso depois dela. O componente também não
 * tem call site e o markup dele está quebrado (ver o `read.md`); é candidato a
 * remoção pelo protocolo, não nesta fase. O arquivo fica para o registro
 * acontecer — é ele que marca `data-initialized="true"` na raiz.
 */

});
